export default __webpack_public_path__ + "static/media/Acme-Regular.9f25ca8b.ttf";